import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import './output.css';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);


// Pipeline trigger - 2026-03-09 14:22:15
